import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h2 } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  @media ${until(Device.TabletSmall)} {
    ${SectionWrapperStyles.SiteWide} {
      padding-left: 0;
      padding-right: 0;
    }

    &:last-child {
      ${SectionWrapperStyles.Inner} {
        padding-bottom: 0;
      }
    }
  }
`;
const Inner = styled.div `
  padding: 30px ${fluid(36, 30)};
  background-color: ${brand.grey.grey91};
`;
const Heading = styled.h2 `
  ${h2};
`;
const DownloadGrid = styled.div `
  width: 100%;

  &[data-download-headings] {
    > *:not(:first-child) {
      display: none;
    }
  }

  @media ${from(Device.Tablet)} {
    display: grid;
    grid-template-columns: 53% 1fr 1fr 1fr;

    &[data-download-headings] {
      > *:not(:first-child) {
        display: block;
      }
    }
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 63% 1fr 1fr 1fr;
  }
`;
const DesktopHeading = styled.span `
  display: none;

  @media ${from(Device.Tablet)} {
    display: block;
  }
`;
const MobileHeading = styled.span `
  display: block;

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const DownloadContent = styled.p `
  text-align: center;
  padding: 0 10px;

  @media ${from(Device.Tablet)} {
    padding: 0 16px;
  }

  &:first-child {
    text-align: left;
  }
`;
const DownloadItem = styled(DownloadGrid) `
  align-items: center;
  margin-top: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
  padding: 10px 0;
  background-color: ${brand.white};

  ${DownloadContent} {
    padding-top: 6px;
    padding-bottom: 6px;

    &:not(:first-child) {
      border-left: 1px solid ${brand.grey.grey44};
    }
  }

  a {
    ${transition('opacity')};

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      opacity: 0.6;
    }
  }

  @media ${until(Device.Tablet)} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 0;

    ${DownloadContent} {
      padding: 10px;

      &:first-child {
        grid-column: span 3;
        border-bottom: 1px solid ${brand.grey.grey44};
      }

      &:not(:first-child) {
        margin: 8px 0;
      }

      &:nth-child(2) {
        border-left: none;
      }
    }
  }
`;
export const DownloadAll = styled(LinkButton) `
  margin-top: ${fluid(20, 24)};
`;
export const DownloadsStyles = {
    Container,
    DesktopHeading,
    DownloadAll,
    DownloadContent,
    DownloadGrid,
    DownloadItem,
    Heading,
    Inner,
    MobileHeading,
};
